import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { RouterOutlet, Router } from '@angular/router';
import { AuthService } from './features/auth/auth.service'; // Importa tu AuthService correctamente

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [HeaderComponent, RouterOutlet, FooterComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService) {}

  async ngOnInit(): Promise<void> {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (code) {
      try {
        const response = await this.authService.getTokens(code).toPromise();
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('id_token', response.id_token);
        if (response.refresh_token) {
          localStorage.setItem('refresh_token', response.refresh_token);
        }
        sessionStorage.setItem('token_exchanged', 'true');
        window.history.replaceState({}, document.title, window.location.pathname);
        this.router.navigate(['/home']);
      } catch (error) {
        console.error('Error al intercambiar el código:', error);
        this.router.navigate(['/error-404']);
      }
    } else {
      const token = localStorage.getItem('access_token');
      if (token) {
        if (this.router.url === '/' || this.router.url === '/index.html') {
          this.router.navigate(['/home']);
        }
      }
    }
  }
}
